import { FormElement } from '../form-element.model';
import { FormElementListingField } from './form-element-listing-field.model';
import { FormFieldRevenueInfo } from '../revenue/form-field-revenue-info.model';

export class FormElementListing extends FormElement {
  // #region Properties

  public PrimaryListing: FormElementListingField;
  public ListingCategory: FormElementListingField;
  public ListingSubCategory: FormElementListingField;
  public LongDescription: FormElementListingField;
  public ShortDescription: FormElementListingField;
  public Keywords: FormElementListingField;
  public AllowAdditional: boolean;
  public AdditionalLimit: number;

  // #endregion

  public constructor() {
    super();

    this.initialize();
  }

  public initialize(): void {
    this.ElementTypeId = 11;

    this.PrimaryListing = new FormElementListingField();
    this.ListingCategory = new FormElementListingField();
    this.ListingSubCategory = new FormElementListingField();
    this.LongDescription = new FormElementListingField();
    this.ShortDescription = new FormElementListingField();
    this.Keywords = new FormElementListingField();
    this.AllowAdditional = false;
    this.AdditionalLimit = null;

    this.PrimaryListing.LabelText = 'Primary Listing';
    this.PrimaryListing.Visible = false;

    this.ListingCategory.LabelText = 'Listing Category';
    this.ListingCategory.Visible = true;

    this.ListingSubCategory.LabelText = 'Listing Subcategory';
    this.ListingSubCategory.Visible = false;

    this.LongDescription.LabelText = 'Long Description';
    this.LongDescription.Visible = false;

    this.ShortDescription.LabelText = 'Short Description';
    this.ShortDescription.Visible = false;

    this.Keywords.LabelText = 'Keywords';
    this.Keywords.Visible = false;

    this.Field.RevenueInfo = [new FormFieldRevenueInfo()];
  }
}
